// src/pages/RefundPolicy.js
import React from "react";

const sections = [
  {
    title: "1. Digital Subscription Services",
    content: [
      "Revibe health and happiness application provides digital fitness services including weight loss programs, exercise routines, Zumba, cardio, and muscle training sessions (excluding yoga).",
      "Once a subscription is activated, users gain instant access to premium content.",
    ],
  },
  {
    title: "2. Cancellation Policy",
    content: [
      "Users may cancel their subscription at any time through account settings or by contacting our support team at support@revibe.app.",
      "Cancellation will stop auto-renewal for the next billing cycle.",
      "Access to premium features remains available until the end of the paid subscription period.",
    ],
  },
  {
    title: "3. Refund Policy",
    subsections: [
      {
        heading: "Non-Refundable Services",
        points: [
          "Subscription fees are generally non-refundable once payment is successfully processed.",
          "Users are responsible for reviewing subscription details before purchase.",
        ],
      },
      {
        heading: "Exceptions for Refunds",
        points: [
          "Refunds may only be issued for duplicate payment due to a technical error.",
          "Refunds may be issued for incorrect billing amount charged.",
          "Refunds may be issued if service was not delivered due to technical failure on our side (after verification).",
        ],
      },
      {
        heading: "No Refund Cases",
        points: [
          "User changes mind after purchase.",
          "User fails to use the subscription.",
          "User faces issues due to poor internet connectivity, device problems, or third-party interruptions.",
        ],
      },
    ],
  },
  {
    title: "4. Refund Process",
    content: [
      "Users must submit a refund request by emailing support@revibe.app within 7 days of the transaction.",
      "All refund requests will be reviewed within 7–10 business days.",
      "Approved refunds will be processed to the original payment method within 7–14 business days, depending on the bank/payment provider.",
    ],
  },
  {
    title: "5. Free Trials",
    content: [
      "If a free trial is offered, users must cancel before the trial ends to avoid automatic billing.",
      "Charges incurred after trial expiration are non-refundable.",
    ],
  },
  {
    title: "6. Payment Disputes",
    content: [
      "Users must first contact Revibe health and happiness application support before initiating a chargeback with their bank/payment provider.",
      "Failure to do so may result in suspension of the user’s account.",
    ],
  },
  {
    title: "7. Contact Us",
    content: [
      `Revibe Health and Happiness
2206, 22nd Floor, Solus, Hiranandani Estate,
Patlipada, Near Hiranandani School,
Thane (West), Maharashtra – 400607
Email: hello@getrevibe.app
Phone: +91 99677 22756`,
    ],
  },
];

const RefundPolicy = () => {
  return (
    <div className="max-w-4xl mx-auto px-6 sm:px-10 lg:px-12 xl:px-16 py-12">
      <h1 className="text-4xl font-bold mb-8 text-gray-900 text-center">
        Refund & Cancellation Policy
      </h1>

      <div className="space-y-8">
        {sections.map((section, index) => (
          <div key={index}>
            <h2 className="text-2xl font-semibold text-gray-800 mb-4">
              {section.title}
            </h2>

            {/* If section has subsections (like Refund Policy) */}
            {section.subsections ? (
              section.subsections.map((sub, i) => (
                <div key={i} className="mb-4">
                  <h3 className="font-medium text-gray-700 mb-2">
                    {sub.heading}
                  </h3>
                  <ul className="list-disc list-inside space-y-2 text-gray-600">
                    {sub.points.map((point, j) => (
                      <li key={j}>{point}</li>
                    ))}
                  </ul>
                </div>
              ))
            ) : (
              <ul className="list-disc list-inside space-y-2 text-gray-600">
                {section.content.map((item, i) => (
                  <li key={i} className="whitespace-pre-line">
                    {item}
                  </li>
                ))}
              </ul>
            )}
          </div>
        ))}
      </div>

      {/* <p className="text-center text-gray-500 mt-12 text-sm">
        © {new Date().getFullYear()} Revibe Health and Happiness. All Rights
        Reserved.
      </p> */}
    </div>
  );
};

export default RefundPolicy;
